export default __webpack_public_path__ + "static/media/ci5.441e857d.png";